/* Visible prev/next arrows for native swipe rows on phones (Hassan, 2026-09-30: "arrows that are easy to notice so they
   know it's a slider"). Targets: homepage collection cards. Arrows sit over the photos, hide at each end. */
(() => {
  const MQ = matchMedia('(max-width: 749px)');
  const TARGETS = ['[id*="__collections"] .mv-cl__grid'];
  const svg = (d) => `<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="${d}" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  function setup(row) {
    if (row.dataset.impArrows) return; row.dataset.impArrows = '1';
    const host = row.parentElement; host.classList.add('imp-row-arrows');
    const mk = (dir) => {
      const b = document.createElement('button'); b.type = 'button';
      b.className = 'imp-row-arrow imp-row-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Previous collections' : 'More collections');
      b.innerHTML = svg(dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7');
      b.addEventListener('click', () => { const item = row.firstElementChild; const step = item ? item.getBoundingClientRect().width + 10 : row.clientWidth * .8; row.scrollBy({ left: dir * step, behavior: 'smooth' }); });
      host.appendChild(b); return b;
    };
    const prev = mk(-1), next = mk(1);
    const place = () => {
      const img = row.querySelector('.card__inner, .card__media, img');
      const hr = host.getBoundingClientRect(), ir = img ? img.getBoundingClientRect() : row.getBoundingClientRect();
      host.style.setProperty('--imp-arrow-top', (ir.top - hr.top + ir.height / 2) + 'px');
      const max = row.scrollWidth - row.clientWidth - 4;
      prev.hidden = !MQ.matches || row.scrollLeft <= 4;
      next.hidden = !MQ.matches || row.scrollLeft >= max;
    };
    row.addEventListener('scroll', place, { passive: true });
    addEventListener('resize', place); MQ.addEventListener('change', place); addEventListener('load', place);
    place();
  }
  const run = () => TARGETS.forEach((sel) => document.querySelectorAll(sel).forEach(setup));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
